// Compact list/card previews (checklist rows, kanban cards) always show a
// plain-text snippet — full rich content only renders in the detail drawer.
// A DOM-based strip (not a regex) so entities and nested tags resolve correctly.
export function stripHtml(html) {
  if (!html) return ''
  const el = document.createElement('div')
  el.innerHTML = html
  return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim()
}
